"use client";

import React from "react";
import Image from "../../assets/images/Transparenz.jpeg"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons'; 

export function Werte() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28 bg-[#5994cf] text-white">
      <div className="container  md:max-w-5xl lg:max-w-7xl mx-auto">
        <div className="grid grid-cols-1 gap-y-12 md:grid-flow-row md:grid-cols-2 md:items-center md:gap-x-12 lg:gap-x-20 ">
        <div>
            <img
              src = {Image} 
              className="w-full object-cover h-[600px] rounded-xl"
              alt="Relume placeholder image"
            />
          </div>
        <div>

<h3 className="text-3xl font-bold mb-5">Unsere Werte</h3>
<div className="grid grid-cols-1 gap-5 py-2 sm:grid-cols-1 ">

<div className="flex flex-row">
<div className="mb-3 md:mb-4">
   <FontAwesomeIcon icon={faCircleCheck} className="text-green-400 w-10 h-12" /> 
</div>
<div>
<h6 className="mb-2 text-md font-bold leading-[1.4] md:mb-2 md:text-xl">
Transparenz              </h6>
<p className="max-w-[500px]">
Sicherheit beginnt mit Klarheit. Wir setzen auf verständliche Lösungen ohne Fachjargon.   </p>       </div>

</div>
<div className="flex flex-row">
<div className="mb-3 md:mb-4">
   <FontAwesomeIcon icon={faCircleCheck} className="text-green-400 w-10 h-12" /> 
</div>
<div>
<h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
Innovation                </h6>
<p className="max-w-[500px]">
Unsere Experten arbeiten mit den neuesten Technologien, um Cyber-Risiken immer einen Schritt voraus zu sein.                </p>
</div>

</div>
<div className="flex flex-row">
<div className="mb-3 md:mb-4">
   <FontAwesomeIcon icon={faCircleCheck} className="text-green-400 w-10 h-12" /> 
</div>
<div>
<h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
Verantwortung           </h6>
<p className="max-w-[500px]">
Wir nehmen die Sicherheit unserer Kunden persönlich und schützen Unternehmen vor den Risiken der digitalen Welt. </p>
</div>

</div>

</div>

</div>
         
        </div>
      </div>
    </section>
  );
}



